import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printSuccess } from '../../output.js'

export const projectsUpdateCommand = new Command(`update`)
  .usage(`<id> --name <name>`)
  .description(`Update a project's name`)
  .argument(`<id>`, `Project ID`)
  .requiredOption(`--name <name>`, `New project name`)
  .action(async (projectId: string, opts) => {
    const json = projectsUpdateCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.projects.update({
        projectId,
        name: opts.name,
      })

      if (isQuiet()) {
        printQuiet(projectId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Project ${projectId} updated.`)
      }
    } catch (error) {
      handleError(error, json)
    }
  })
